// ═══════════════════════════════════════════════════════════════
// FRONTEND API SERVICE: Personas Relacionadas
// Path: src/api/relatedPersons.js
// ═══════════════════════════════════════════════════════════════

import apiConfig from './config';

const BASE = '/related-persons';

/** Lista personas relacionadas de la compañía con filtros opcionales. */
export const getRelatedPersons = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.employeeId)            params.append('employeeId',           filters.employeeId);
  if (filters.relationship)          params.append('relationship',         filters.relationship);
  if (filters.isHealthDependent)     params.append('isHealthDependent',    'true');
  if (filters.isAdditionalDependent) params.append('isAdditionalDependent','true');
  if (filters.isEmergencyContact)    params.append('isEmergencyContact',   'true');
  if (filters.isBeneficiary)         params.append('isBeneficiary',        'true');
  if (filters.active !== undefined)  params.append('active', String(filters.active));
  const qs = params.toString();
  const response = await apiConfig.get(`${BASE}${qs ? `?${qs}` : ''}`);
  return response.data;
};

/**
 * Resumen de dependientes de salud por empleado.
 * Usado por el módulo de Seguridad Social para calcular cápita.
 * Retorna: [{ employee_id, dependent_count, total_monthly_capita }]
 */
export const getHealthDependentsSummary = async () => {
  const response = await apiConfig.get(`${BASE}/health-dependents`);
  return response.data;
};

/**
 * Resumen de dependientes adicionales por empleado.
 * Usado por el módulo ISR / Beneficios Fiscales.
 * Retorna: [{ employee_id, dependent_count }]
 */
export const getAdditionalDependentsSummary = async () => {
  const response = await apiConfig.get(`${BASE}/additional-dependents`);
  return response.data;
};

/** Todas las personas relacionadas de un empleado específico. */
export const getRelatedPersonsByEmployee = async (employeeId) => {
  const response = await apiConfig.get(`${BASE}/employee/${employeeId}`);
  return response.data;
};

/** Crear nueva persona relacionada. */
export const createRelatedPerson = async (data) => {
  const response = await apiConfig.post(BASE, data);
  return response.data;
};

/** Actualizar persona relacionada. */
export const updateRelatedPerson = async (id, data) => {
  const response = await apiConfig.put(`${BASE}/${id}`, data);
  return response.data;
};

/** Eliminar persona relacionada. */
export const deleteRelatedPerson = async (id) => {
  const response = await apiConfig.delete(`${BASE}/${id}`);
  return response.data;
};
